import React, { PropTypes }   from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import $ from 'jquery';
import cx from 'classnames';
import SeekSlider from './seek-slider';
import PlayPauseToggleButton from './play-pause-toggle-button';
import TimeLabel from './time-label';
import VolumeController from './volume-controller';
import ControlStore from './controls-store';
import FullScreenToggleButton from './full-screen-toggle-button';
/*
  Player Controls

  The player controls are rendered from the current state of the <video> object.

  Each component updates/re-renders only when their property from the component's state changes.
*/

export default class PlayerControls extends Reflux.Component{
  constructor(props) {
    super(props);
    this.state = {};
    this.store = ControlStore.get(props, this.props.route);
  }
  shouldComponentUpdate(nextProps, nextState) {
      return nextState.isReady!=this.state.isReady;
  }
  componentWillUnmount() {
    this.store.stopListeningToAll();
    ControlStore.clearCache();
  }
  render() {
    if(!this.state.isReady) {
      return false;
    }
    const controlClass = cx({
      'video-controls': true,
      'video-buttons': true
    });
    const controlProps = {
      className: controlClass
    }
    return (
      <div {...controlProps}>
        <SeekSlider ControlsStore={this.store}/>
        <div className="play-buttons-bar">
          <PlayPauseToggleButton ControlsStore={this.store} />
          <TimeLabel ControlsStore={this.store} />
          <VolumeController ControlsStore={this.store} />
          <FullScreenToggleButton ControlsStore={this.store} />
        </div>
      </div>
    );
  }
}

PlayerControls.propTypes={
  "config-id": PropTypes.string,
  "toggleFullscreen": PropTypes.func
}
PlayerControls.defaultProps={
  "toggleFullscreen": ()=>{}
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/controls.jsx